export const RouteName = {
    DEFAULT_ROUTE: "/translate",
    MEETING_URL: "/translate/:sessionId",
};
